import React from 'react'
import { SidebarLayout } from './components/SidebarLayout';
import { SidebarBrand } from './components/SidebarBrand';
import { SidebarMenu } from './components/SidebarMenu';
import { SidebarFooterCard } from './components/SidebarFooterCard';

export const Sidebar = () => {
  return (
    <SidebarLayout>
        <SidebarBrand />
        <SidebarMenu />
        <SidebarFooterCard />
    </SidebarLayout>
  )
}
